<template lang="pug">
  .shop-fix
    .has-temp(v-if="isCanUseAppTemp || isCanUsePcTemp")
      el-form(:inline="true"  label-width="100px")
        el-form-item
          el-button.created-btn(type="primary" size="mini" @click="refresh") 刷新
  
      el-tabs.tabs(v-model="appType" @tab-click="changeTabs")
        el-tab-pane(name="1" label="手机端")
        el-tab-pane(name="2" label="电脑端")
      
      h3.temp-type 官方模版
      ul.temp-list
        li.item(v-for="temp in defaultTempList" :key="temp.id")
          .preview
            img.temp-cover(v-if="appType === '1'" src="@/assets/temp-cover-app.jpg")
            img.temp-cover(v-if="appType === '2'" src="@/assets/temp-cover-pc.jpg")
            .opt
              .mask
                el-button.opt-btn(type="primary" size="mini" @click="createdTemp(temp.id)") 创建自定义模版
          .name {{temp.name}}
      .empty(v-if="isShowDefaultTempEmpty")
        img(src="@/assets/order-empty.png")
        .tips 暂时没有可以使用的官方模版

      h3.temp-type 我的模版
      ul.temp-list
        li.item(v-for="temp in customTempList" :key="temp.id")
          .preview
            img.temp-cover(v-if="appType === '1'" src="@/assets/temp-cover-app.jpg")
            img.temp-cover(v-if="appType === '2'" src="@/assets/temp-cover-pc.jpg")
            .tag-box
              .use-tag(v-if="temp.status === 2") 正在使用
            .opt
              .mask
                .opt-btn
                  el-button(type="primary" size="mini" @click="createdTemp(temp.parentId, temp.id)") 修改模版
                  el-button(type="primary" size="mini" v-if="temp.status === 2" @click="userTemp(temp.id, 1)") 停止使用
                  el-button(type="primary" size="mini" v-if="temp.status === 1" @click="userTemp(temp.id, 2)") 使用模版
          .name {{temp.name}}
      .empty(v-if="isShowCustomTempEmpty")
        img(src="@/assets/order-empty.png")
        .tips 暂时没有模版
    .no-temp(v-else)
      img.temp-cover(src="@/assets/empty-temp-introduce-1.jpg")
      img.temp-cover(src="@/assets/empty-temp-introduce-2.jpg")
      img.temp-cover(src="@/assets/empty-temp-introduce-3.jpg")
      img.temp-cover(src="@/assets/empty-temp-introduce-4.jpg")
      img.temp-cover(src="@/assets/empty-temp-introduce-5.jpg")
</template>
<script>
export default {
  name: 'shopTemp',
  data() {
    return {
      defaultTempList: '',
      customTempList: '',
      appType: '1',
      isShowDefaultTempEmpty: false,
      isShowCustomTempEmpty: false,
      shopId: '',
      isCanUseAppTemp: true,
      isCanUsePcTemp: true
    }
  },
  methods: {
    // 获取关联的默认模板
    async getDefaultTemp(_appType) {
      const appType = _appType || this.appType * 1
      try {
        const result = await this.$get('resourcecenter.decorate.getDefaultTemplatesForRelation', {
          outType: 1,
          appType,
          outId: this.shopId
        })
        if (result.success) {
          const list = result.data[0].value || []
          if (appType === this.appType * 1) {
            this.defaultTempList = list
            this.isShowDefaultTempEmpty = list.length === 0
          }
          if (appType === 1) {
            this.isCanUseAppTemp = list.length > 0
          }
          if (appType === 2) {
            this.isCanUsePcTemp = list.length > 0
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 查询自定义模板
    async getCustomTemp() {
      try {
        const result = await this.$get('resourcecenter.decorate.getTemplates', {
          outType: 1,
          appType: this.appType * 1,
          outId: this.shopId
        })
        if (result.success) {
          this.customTempList = result.data[0].value || []
          this.isShowCustomTempEmpty = this.customTempList.length === 0
        }
        console.log(this.tempList)
      } catch (err) {
        console.log(err)
      }
    },
    createdTemp(parentId, id) {
      const { href } = this.$router.resolve({
        name: 'createdTemp',
        params: {
          platform: this.appType === '1' ? 'mobile' : 'pc',
          shopId: this.shopId,
          parentId,
          id
        }
      })
      window.open(href, '_blank')
    },
    changeTabs() {
      this.getCustomTemp()
      this.getDefaultTemp()
    },
    /** 获取店铺信息 */
    async getShopInfo() {
      try {
        const result = await this.$get('shop.adminGetCurrentShop')
        if (result.success) {
          this.shopId = result.data[0] && result.data[0].id
          if (this.shopId) {
            this.getDefaultTemp(1)
            this.getDefaultTemp(2)
            this.getCustomTemp()
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /**
     * 使用模版
     * templateId 模板id
     * status 状态：1未发布/2已发布
     * */
    async userTemp(templateId, status) {
      try {
        const result = await this.$get('resourcecenter.decorate.modifyTemplateStatus', {
          templateId,
          status
        })
        if (result.success) {
          this.getCustomTemp()
          this.$message.success('操作成功')
        }
      } catch (err) {
        console.log(err)
      }
    },
    refresh() {
      this.getDefaultTemp(1)
      this.getDefaultTemp(2)
      this.getCustomTemp()
    }
  },
  created() {
    this.getShopInfo()
  }
}
</script>

<style lang="stylus" scoped>
/deep/.tabs
  .el-tabs__nav
    margin-left 30px
.created-btn
  margin-left 30px
.temp-type
  margin-top 25px
.temp-list
  display flex
  flex-wrap wrap

  .item
    margin 15px
    text-align center
    font-size 14px

  .preview
    width 200px
    height 300px
    background-color #f5f5f5
    margin-bottom 15px
    position relative

    &:hover
      .opt
        height 100%
      .opt-btn
        display block
    .opt
      position absolute
      width 100%
      height 0
      top 0
      left 0
      transition height .3s
    .mask
      width 100%
      height 100%
      background-color rgba(0,0,0,.4)
    .opt-btn
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      display none

      button
        margin 10px 0 0 0 !important
.empty
  margin-top 50px
  text-align center
  img
    width 100px
    height 100px

  .tips
    text-align center
    margin-top 20px
    color #999
    font-size 14px
.tag-box
	width 95px
	height 90px
	overflow hidden
	position absolute
	top -3px
	left -3px

.use-tag
  color #fff
  font-size 12px
  text-align center
  text-shadow rgba(255, 255, 255, 0.5) 0px 1px 0px
  transform rotate(-45deg)
  position relative
  padding 7px 0
  left -25px
  top 20px
  width 120px
  background-color #d0111a
  box-shadow 0px 0px 3px rgba(0, 0, 0, 0.3)

  &:before, &:after
    content ''
    border-top 3px solid #f0242e
    border-left 3px solid transparent
    border-right 3px solid transparent
    position absolute
    bottom -3px

  &:before
    left 0
  &:after
    right 0
.temp-cover
  width 100%
  height 100%
  object-fit cover
</style>
